var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaturalDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Facets",
    viewBox: "0 0 14.98 14.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n            fill: #f3f3f3;\n            }\n\n            .cls-2 {\n            fill: #f6f6f6;\n            }\n\n            .cls-3 {\n            fill: #f2f2f2;\n            }\n\n            .cls-4 {\n            fill: #f9f9f9;\n            }\n\n            .cls-5 {\n            fill: #f0f0f0;\n            }\n\n            .cls-6 {\n            fill: #eaeaea;\n            }\n\n            .cls-7 {\n            fill: #e9e9e9;\n            }\n\n            .cls-8 {\n            fill: #f4f4f4;\n            }\n\n            .cls-9 {\n            fill: #f5f5f5;\n            }\n\n            .cls-10 {\n            fill: #e8e8e8;\n            }\n\n            .cls-11 {\n            fill: #e5e5e5;\n            }\n\n            .cls-12 {\n            fill: #efefef;\n            }\n\n            .cls-13 {\n            fill: #e4e4e4;\n            }\n\n            .cls-14 {\n            fill: #ddd;\n            }\n\n            .cls-15 {\n            fill: #dcdcdc;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m3.45,5.8l-.49-2.79,1.64-2.43c-1.79.75-3.22,2.17-3.99,3.95l2.34-1.52.5,2.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m10.4.61C9.51.22,8.53,0,7.49,0s-2,.21-2.89.58l2.89.48,2.91-.45Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m14.42,4.63c-.74-1.8-2.17-3.23-3.96-4l1.65,2.4,2.3,1.61Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m.61,4.54C.22,5.44,0,6.44,0,7.49s.21,2.03.59,2.92l.53-2.83-.52-3.04Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m4.47,14.34c.92.41,1.94.64,3.02.64s2.09-.23,3.01-.63l-3.15-.42-2.88.42Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m.59,10.41c.74,1.75,2.13,3.15,3.87,3.92l-1.49-2.31-2.37-1.61Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m10.5,14.35c1.73-.76,3.1-2.16,3.85-3.89l-2.28,1.44-1.56,2.45Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m14.37,10.42c.38-.9.61-1.89.61-2.93s-.2-1.98-.56-2.86l-.55,3.01.5,2.77Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "9.3 3.35 5.86 3.36 3.45 5.8 3.41 9.21 5.79 11.58 9.16 11.62 11.53 9.17 11.57 5.8 9.3 3.35"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.49 1.06 5.86 3.36 9.3 3.35 7.49 1.06"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "2.97 12.02 5.79 11.58 3.41 9.21 2.97 12.02"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "7.35 13.92 9.16 11.62 5.79 11.58 7.35 13.92"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "11.53 9.17 13.87 7.64 11.57 5.8 11.53 9.17"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "12.07 11.9 11.53 9.17 9.16 11.62 12.07 11.9"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1.13 7.58 3.41 9.21 3.45 5.8 1.13 7.58"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "2.96 3.01 3.45 5.8 5.86 3.36 2.96 3.01"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "12.11 3.02 9.3 3.35 11.57 5.8 12.11 3.02"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "3.45 5.8 2.95 3.01 .61 4.53 .61 4.53 .61 4.54 1.13 7.58 3.45 5.8"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "5.86 3.36 7.49 1.06 4.6 .58 4.6 .58 4.6 .58 2.96 3.01 5.86 3.36"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "11.57 5.8 13.87 7.64 14.42 4.63 14.42 4.63 12.11 3.02 11.57 5.8"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "9.3 3.35 12.11 3.02 10.46 .63 10.44 .6 10.4 .61 7.49 1.06 9.3 3.35"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "3.41 9.21 1.13 7.58 .59 10.41 .59 10.41 .59 10.41 2.97 12.02 3.41 9.21"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "5.79 11.58 2.97 12.02 4.46 14.33 4.46 14.34 4.47 14.34 7.35 13.92 5.79 11.58"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "14.37 10.42 13.87 7.64 11.53 9.17 12.07 11.9 14.35 10.46 14.37 10.45 14.37 10.42"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "9.16 11.62 7.35 13.92 10.5 14.35 12.07 11.9 9.16 11.62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaturalDiamond);
export default __webpack_public_path__ + "static/media/NaturalDiamond.568d7e408628ccaaef652d876adc9eb1.svg";
export { ForwardRef as ReactComponent };